import {
  fromJS,
  Map as ImmutableMap,
  List as ImmutableList,
} from 'immutable'
import {
  MARKETPLACE_LISTING_CREATE_REQUEST,
  MARKETPLACE_LISTING_CREATE_FAIL,
  MARKETPLACE_LISTING_CREATE_SUCCESS,
  MARKETPLACE_LISTING_UPDATE_REQUEST,
  MARKETPLACE_LISTING_UPDATE_FAIL,
  MARKETPLACE_LISTING_UPDATE_SUCCESS,
  MARKETPLACE_LISTING_EDITOR_RESET,
  MARKETPLACE_LISTING_EDITOR_SETUP,
  MARKETPLACE_LISTING_EDITOR_ATTR_CHANGE,
  MARKETPLACE_LISTING_UPLOAD_REQUEST,
  MARKETPLACE_LISTING_UPLOAD_PROGRESS,
  MARKETPLACE_LISTING_UPLOAD_SUCCESS,
  MARKETPLACE_LISTING_UPLOAD_FAIL,
  MARKETPLACE_LISTING_UPLOAD_UNDO,
  MARKETPLACE_LISTING_UPLOAD_SET,
} from '../actions/marketplace_listing_editor'
// import { MARKETPLACE_LISTING_AVAILABLE_UNIQUE_ATTRIBUTES } from '../constants'
// const defaultInnerAttributes = {};
// MARKETPLACE_LISTING_AVAILABLE_UNIQUE_ATTRIBUTES.forEach(attribute => {
//   defaultInnerAttributes[attribute] = ''
// })

const initialState = ImmutableMap({
  isSubmitting: false,
  isChanged: false,
  attrs: ImmutableMap({
    title: '',
    location: '',
    location_object: {},
    description: '',
    category: null,
    condition: 0,
    business_id: null,
    cta_title: null,
    cta_link: null,
    attrs: ImmutableMap({}),
  }),
  id: '',
  upload_progress: 0,
  is_uploading: false,
  pending_media_attachments: 0,
  media_attachments: ImmutableList(),
})

const appendMedia = (state, media) => {
  return state.withMutations(map => {
    map.update('media_attachments', list => list.push(media));
    map.set('is_uploading', false);
    map.update('pending_media_attachments', n => n - 1)
  });
};

const removeMedia = (state, mediaId) => {
  return state.withMutations(map => {
    map.update('media_attachments', list => list.filterNot(item => item.get('id') === mediaId));
  });
};

export default function marketplaceListingEditorReducer(state = initialState, action) {
  switch(action.type) {
  case MARKETPLACE_LISTING_EDITOR_RESET:
    return initialState
  case MARKETPLACE_LISTING_EDITOR_SETUP:
    const innerAttrs = action.item.get('attrs')
    let innerAttrsSetter = ImmutableMap({})
    if (ImmutableList.isList(innerAttrs)) {
      innerAttrsSetter = innerAttrs.reduce((acc, item) => {
        let theValue = item.get('value')
        const theType = item.get('type')
        if (theType === 'boolean') theValue = theValue.toLowerCase() === 'yes' ? true : false
        if (['color', 'year', 'select'].indexOf(theType) > -1) theValue = theValue.toLowerCase()
        return acc.set(item.get('key'), theValue)
      }, ImmutableMap())
    }

    return state.withMutations((map) => {
      const basicMap = ImmutableMap({
        title: action.item.get('title'),
        description: action.item.get('description'),
        location: action.item.get('location'),
        price: action.item.get('price'),
        condition: action.item.get('condition'),
        category: action.item.getIn(['marketplace_listing_category', 'id']),
        attrs: innerAttrsSetter,
      })
      
      map.set('attrs', basicMap)
      map.set('media_attachments', action.item.get('media_attachments'))
      map.set('isSubmitting', false)
    })
  case MARKETPLACE_LISTING_EDITOR_ATTR_CHANGE:
    const theKey = Array.isArray(action.listing_key) ? ['attrs', ...action.listing_key] : ['attrs', action.listing_key]
    state = state.setIn(theKey, action.listing_value)
    state = state.set('isChanged', true)
    return state

  case MARKETPLACE_LISTING_CREATE_REQUEST:
  case MARKETPLACE_LISTING_UPDATE_REQUEST:
    return state.withMutations((map) => {
      map.set('isSubmitting', true)
      map.set('isChanged', false)
    })
  case MARKETPLACE_LISTING_CREATE_FAIL:
  case MARKETPLACE_LISTING_UPDATE_FAIL:
    return state.set('isSubmitting', false)
  case MARKETPLACE_LISTING_CREATE_SUCCESS:
  case MARKETPLACE_LISTING_UPDATE_SUCCESS:
    return state.withMutations((map) => {
      map.set('isSubmitting', false)
    })

  case MARKETPLACE_LISTING_UPLOAD_REQUEST:
    return state.set('is_uploading', true).update('pending_media_attachments', n => n + 1)
  case MARKETPLACE_LISTING_UPLOAD_SUCCESS:
    state = state.set('progress', 0)
    return appendMedia(state, fromJS(action.media));
  case MARKETPLACE_LISTING_UPLOAD_FAIL:
    return state.set('is_uploading', false).update('pending_media_attachments', n => action.decrement ? n - 1 : n);
  case MARKETPLACE_LISTING_UPLOAD_UNDO:
    return removeMedia(state, action.media_id);
  case MARKETPLACE_LISTING_UPLOAD_PROGRESS:
    return state.set('progress', Math.round((action.loaded / action.total) * 100));
  case MARKETPLACE_LISTING_UPLOAD_SET:
    return state.withMutations((map) => {
      map.set('media_attachments', action.medias)
    })

  default:
    return state
  }
}
